module.exports = __webpack_public_path__ + "d6ef1a2c51edd4cc51bada135226fc.png";